import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=548a4f66&scoped=true"
import script from "./tip.vue?vue&type=script&lang=js"
export * from "./tip.vue?vue&type=script&lang=js"
import style0 from "./tip.vue?vue&type=style&index=0&id=548a4f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a4f66",
  null
  
)

export default component.exports